import React, { InputHTMLAttributes, useRef } from "react";

import {
  InputContainer,
  Label,
  RadioInput,
  DisabledText,
  WrapperInputs,
} from "./styles";

interface IInputStyledProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  mobile?: boolean;
  label: React.ReactNode;
  button?: React.ReactNode;
}

const Radio = ({
  id,
  name,
  label,
  button,
  mobile,
  checked,
  disabled,
  ...rest
}: IInputStyledProps) => {
  const radioRef = useRef<HTMLInputElement>(null);

  const onClickContainer = () => {
    radioRef.current.click();
  };

  return (
    <InputContainer
      mobile={mobile}
      disabled={disabled}
      onClick={onClickContainer}
      checked={checked}
    >
      <RadioInput
        id={id}
        name={name}
        type="radio"
        ref={radioRef}
        checked={checked}
        disabled={disabled}
        {...rest}
      />
      <Label htmlFor={id}>{label}</Label>

      {disabled && !mobile && (
        <DisabledText>Temporariamente indisponivel</DisabledText>
      )}

      {!!button && !disabled && button}
    </InputContainer>
  );
};

export { WrapperInputs };
export default Radio;
